import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/program/ManageProgramSeeMore.css";
import ProgramApi from "../../api/programApi";
import moment from "moment";
import { toast } from "react-toastify";
import AlertPopup from "../../components/AlertPopup";
import { downloadFile } from "../../utils/download";
import MeetingProgramReviewApi from "../../api/meetingProgramReviewApi";

const ManageProgramSeeMore = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const { id } = useParams();
  //--삭제 state--//
  const [isOpen, setIsOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("삭제 하시겠습니까?");
  const [content, setContent] = useState(
    "삭제된 데이터는 복구가 불가능합니다."
  );
  const [alertValue, setAlertValue] = useState(false);
  const [cancelTitle, setCancelTitle] = useState("취소");
  const [confirmTitle, setConfirmTitle] = useState("삭제");
  //--삭제 state--//

  const [programId, setProgramId] = useState(null);
  const [programInfo, setProgramInfo] = useState({});
  const [reviewList, setReviewList] = useState([]);
  const [reviewCount, setReviewCount] = useState(null);
  const [reviewPostsPerPage, setReviewPostsPerPage] = useState(null);
  const [reviewcurrentPage, setReviewCurrentPage] = useState(1);
  const [reviewstartIndex, setReviewStartIndex] = useState(0);
  const [reviewpageIndex, setReviewPageIndex] = useState([]);
  const [reviewSubMenu, setReviewSubMenu] = useState(null);

  useEffect(() => {
    try {
      if (location.state) {
        const { id } = location.state;
        setProgramId((id) => location.state.id);
        getProgramInfo(id);
      }
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  }, [location]);

  const getProgramInfo = async (id) => {
    try {
      const info = (await ProgramApi.GetProgram(id)).data.data.content;
      setProgramInfo(info);
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  //삭제 실행하는 곳
  const programHandler = async () => {
    setIsOpen(true);
    setDeleteId(programId);
  };

  const [deleteId, setDeleteId] = useState(-1);
  useEffect(() => {
    const del = async () => {
      try {
        if (deleteId <= 0) {
          return;
        }
        await ProgramApi.DelProgram(deleteId);
        toast("삭제되었습니다.");
        navigate("/admin/program/1");
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  const fileDownload = async (serverFileName, originFileName) => {
    try {
      const data = {
        serverFileName: serverFileName,
        originFileName: originFileName,
      };
      const response = await ProgramApi.FileDownload(data);
      downloadFile(response, originFileName);
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    let page = Math.ceil(reviewCount / reviewPostsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setReviewPageIndex(arr);
  }, [reviewCount]);

  useEffect(() => {
    const getReviewInfo = async () => {
      try {
        const reviewInfo = (
          await MeetingProgramReviewApi.Get({
            page: reviewcurrentPage,
            size: 8,
            programId: Number(id),
          })
        ).data.data;
        setReviewList(reviewInfo.content);
        setReviewCount(reviewInfo.totalCount);
        setReviewPostsPerPage(reviewInfo.content.length);

        const reviewCount = Math.ceil(
          reviewInfo.reviewCount / reviewInfo.content.length / 4
        );

        for (let i = 1; i <= reviewCount; i++) {
          if (reviewcurrentPage / 4 <= i) {
            setReviewStartIndex(4 * (i - 1));
          }
        }
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    getReviewInfo();
  }, [reviewcurrentPage]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-program-seemore">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
          <div>
            <Link onClick={programHandler}>삭제</Link>
            <Link
              to={`/admin/program/edit/${programId}`}
              state={{ id: programId }}
            >
              수정하기
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-program-see-more">
          <span>상세</span>
          <div className="Manage-form-view-details Manage-form-view-details-program-seemore">
            <span>프로그램명</span>
            <span>{programInfo.title}</span>
          </div>
          <div className="Manage-form-view-details Manage-form-view-details-program-seemore">
            <span>소요시간</span>
            <span>{`${programInfo.requiredTime} 시간`}</span>
          </div>
          <div className="Manage-form-view-details Manage-form-view-details-program-seemore manage-flex-start">
            <span>상세설명</span>
            <span>{programInfo.content}</span>
          </div>
          <div className="Manage-form-view-details Manage-form-view-details-program-seemore">
            <span>
              이미지
              <br />
              (*최대 5장)
            </span>
            <div className="Manage-form-view-details-img Manage-form-view-details-img-program">
              {programInfo.programFiles &&
                programInfo.programFiles.map((item, index) => {
                  return (
                    <div key={index} className="program-detail-img-container">
                      <div className="program-detail-img">
                        <img src={item.imageUrl} />
                      </div>
                      <div>
                        <a
                          onClick={() => {
                            fileDownload(
                              item.imageServerFileName,
                              item.imageOriginFileName
                            );
                          }}
                        >
                          <span>{item.imageOriginFileName}</span>
                          <img src="\img\download_black.svg" />
                        </a>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="Manage-form manage-form-program-see-more program-see-more-review">
          <div>
            <span>리뷰 관리</span>
            <span>{`${reviewCount}개`}</span>
          </div>
          <table>
            <thead>
              <tr>
                <th>이메일</th>
                <th>별명</th>
                <th>작성일자</th>
                <th>평점</th>
                <th>리뷰 상태</th>
                <th>상세보기</th>
              </tr>
            </thead>
            <tbody>
              {reviewList.map((item, index) => {
                let createDate = moment(item.createdAt)
                  .local()
                  .format("YYYY/MM/DD");
                return (
                  <tr key={index}>
                    <td>{item.member.email}</td>
                    <td>
                      <span>{item.member.nickname}</span>
                    </td>
                    <td>{createDate}</td>
                    <td>{item.score}</td>
                    <td className="table-sub-catagory-container">
                      <a
                        onClick={() => {
                          if (reviewSubMenu === index) {
                            setReviewSubMenu(null);
                          } else {
                            setReviewSubMenu(index);
                          }
                        }}
                      >
                        <span>{item.activation ? "일반" : "숨김"}</span>
                        <img src="\img\table-togle.svg" />
                      </a>
                      {reviewSubMenu === index ? (
                        <ul className="table-sub-menu">
                          <li
                            onClick={() => {
                              let copyData = [...reviewList];
                              copyData[index].activation = true;
                              setReviewList(copyData);
                              // reviewActivation(item.id, true);
                              setReviewSubMenu(null);
                            }}
                          >
                            일반
                          </li>
                          <li
                            onClick={() => {
                              let copyData = [...reviewList];
                              copyData[index].activation = false;
                              setReviewList(copyData);
                              // reviewActivation(item.id, false);
                              setReviewSubMenu(null);
                            }}
                          >
                            숨김
                          </li>
                        </ul>
                      ) : null}
                    </td>
                    <td>
                      <Link
                        to={`/admin/meeting-program-review/${item.id}`}
                        state={{ id: item.id }}
                      >
                        <img src="\img\see-more-btn-plus.svg" />
                        <span>보기</span>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="manage-table-pagenation-container">
            <div className="manage-table-pagenation">
              <a
                onClick={() => {
                  if (reviewcurrentPage <= 1) {
                    return;
                  } else {
                    setReviewCurrentPage(reviewcurrentPage - 1);
                  }
                }}
              >
                <img src="\img\chevron-left.svg" />
              </a>
              {reviewpageIndex
                .slice(reviewstartIndex, reviewstartIndex + 4)
                .map((item, index) => {
                  return (
                    <a
                      key={index}
                      className={
                        reviewcurrentPage === item ? "pagenation-focus" : null
                      }
                      onClick={() => {
                        setReviewCurrentPage(item);
                      }}
                    >
                      {item}
                    </a>
                  );
                })}
              <a
                onClick={() => {
                  if (reviewcurrentPage >= reviewpageIndex.length) {
                    return;
                  } else {
                    setReviewCurrentPage(reviewcurrentPage + 1);
                  }
                }}
              >
                <img src="\img\chevron-right.svg" />
              </a>
            </div>
          </div>
        </div>
        {/* 삭제 컴포넌트 */}
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={headerTitle}
          content={content}
          setAlertValue={setAlertValue}
          cancelTitle={cancelTitle}
          confirmTitle={confirmTitle}
        />
      </section>
    </div>
  );
};

export default ManageProgramSeeMore;
